import React from "react";
import Loadable from "../../react-loadable";

const WeaTag = Loadable({
  loader: () => import("./Tag"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaTag;



// WEBPACK FOOTER //
// ./ecology9/wea-tag/index.js